// extracted by mini-css-extract-plugin
export var excerpt = "feature-preview-module--excerpt--a38ac typography-module--paragraph--e56c7";
export var item = "feature-preview-module--item--f5cf8";
export var root = "feature-preview-module--root--bd83e";
export var subtitle = "feature-preview-module--subtitle--af915 typography-module--responsiveTitle4--45808";
export var title = "feature-preview-module--title--12249 typography-module--responsiveTitle5Sans--eb804";